<template>
    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex flex-col gap-6">
            <h2 class="text-2xl md:text-4xl font-semibold">Patient Overview: Initial Presentation</h2>

            <div class="">
                <h3 class="text-base md:text-2xl font-semibold mb-3">
                    A 30-year-old woman presented to the clinic with post-partum kidney failure
                </h3>

                <ul class="list-disc pl-4  font-light">
                    <li>
                        The pregnancy history was unremarkable, with normal blood pressure and creatinine (0.5 mg/dL in the third trimester)
                    </li>
                </ul>
            </div>

            <div class="">
                <h3 class="text-base md:text-2xl font-semibold mb-3">Relevant medical history</h3>
                <div class="flex flex-col gap-3">
                    <div class="p-5 text-white rounded bg-maroon">
                        Vomiting
                    </div>
                    <div class="p-5 text-white rounded bg-purple">
                        Decreased urinary output
                    </div>
                    <div class="p-5 text-white rounded bg-darkerblue">
                        Delivered a full-term baby via LSCS 4 days prior to presentation
                    </div>
                </div>
            </div>

            <div class="">
                <h3 class="text-base md:text-2xl font-semibold mb-3">Family history</h3>
                <ul class="list-disc pl-4  font-light">
                    <li>
                        Born to consanguineous parents
                    </li>
                </ul>
            </div>
        </div>

        <img src="@/assets/img/graphics/postpartum/postpartum-woman.svg" alt="Female body" :style="{ maxHeight: '780px' }" />
    </div>
</template>
